import Vue from 'vue'

export const HUB_EVENTS = {
  REV_VIEW: {
    BEFORE_ROUTE_LEAVE: 'beforeRouteLeave',
    REPLICATE_REV: 'replicateRev',
  },

  TASK_CREATION_DRAWER: {
    CREATE: 'createTask',
    CREATED: 'taskCreated',
  },

  TASK_EDITION_DRAWER: {
    UPDATE: 'updateTask',
    UPDATED: 'taskUpdated',
    DELETED: 'deleteTask',
    COMPLETED: 'completeTask',
  },

  TASK_KANBAN: {
    UPDATED: 'taskUpdated',
    DUPLICATED: 'taskDuplicated',
    DELETED: 'taskDeleted',
  },

  BOARD_VIEW: {
    UPDATED: 'boardItemUpdated',
  },

  ENTITY_DRAWER: {
    UPDATE: 'updateEntity',
    UPDATED: 'entityUpdated',
    DELETED: 'entityDeleted',
  },

  AI: {
    HUB_DIALOG_OPEN: 'hubDialogOpen',
    TASK_CREATED: 'taskCreated',
  },

  ROUTINE_APPROVAL: {
    UPDATED: 'routineApprovalUpdated',
  },
}

export default new Vue()
